import type { ReactNode } from "react";

interface EmptyStateProps {
  title: string;
  /** What this kind of thing is, and how one comes to exist. */
  description: ReactNode;
  action?: ReactNode;
  /** Shown when the user cannot do anything about it — who to ask, typically. */
  footnote?: ReactNode;
}

/**
 * An empty list is a question ("is it broken, or is there nothing?") and this is
 * the answer. It always explains what would fill the space, and when the reader
 * is not allowed to fill it, who is.
 */
export function EmptyState({ title, description, action, footnote }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-line px-6 py-10 text-center">
      <h3 className="text-sm font-bold text-ink">{title}</h3>
      <p className="max-w-prose text-sm text-ink-soft">{description}</p>
      {action}
      {footnote && <p className="max-w-prose text-xs text-ink-soft">{footnote}</p>}
    </div>
  );
}
